export const PlaystoreBadge = () => {
  return (
    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.jspn.vvs&pli=1" rel="external" style={{ color: "unset" }}>
      <img src="/images/google-play-badge.png" width="200px" style={{ marginLeft: "-16px" }} alt="Playstore download badge" />
    </a>
  );
};
